// TODO: remove
export const addQueryParam = (
  searchQuery: URLSearchParams,
  key: string,
  value?: string | number | null,
): void => {
  if (value !== null && value !== undefined && value !== '') {
    searchQuery.append(key, value.toString())
  }
}
